import * as common from './types';

const mutations = {
  [common.SET_ERROR](state, error) {
    state.error = error;
  },
  [common.APPLOADED](state) {
    state.appLoaded = true;
  },
  [common.SET_LOADING](state, b) {
    state.loading = b;
  },
  [common.PUT_GLOBAL_MESSAGE](state, message) {
    state.globalMessage.unshift(message);
  },
  [common.DELETE_GLOBAL_MESSAGE](state, message) {
    const index = state.globalMessage.findIndex(
      _message => _message === message,
    );
  },
  [common.SET_LOADER](state, b) {
    state.showLoader = b;
  },
  [common.SET_SNACKBAR](state, data) {
    if (data.color == true) {
      data.color = 'success';
    }
    if (data.color == false) {
      data.color = 'error';
    }
    state.snackbar.snackbarPosX = data.posX || '';
    state.snackbar.snackbarPosY = data.posY || '';
    state.snackbar.snackbarDuration = data.duration || 3000;
    state.snackbar.snackbarMessage = data.message || 'No message.';
    state.snackbar.snackbarMultiLine = data.multiLine || false;
    state.snackbar.snackbarColor = data.color || 'info';
    state.snackbar.showSnackbar = true;
  },
  [common.SET_SHOW_SNACKBAR](state, b) {
    state.snackbar.showSnackbar = b;
  },
  [common.SET_DIALOG](state, data) {
    state.dialog.dialogType = data.type || 'confirm';
    state.dialog.dialogTitle = data.title;
    state.dialog.dialogMessage = data.message;
    state.dialog.dialogHtml = data.html || false;
    state.dialog.dialogIcon = data.icon || null;
    state.dialog.dialogOkCb = data.okCb || function() {};
    state.dialog.dialogCancelCb = data.cancelCb || function() {};
    state.dialog.dialogShow = true;
  },
  [common.SET_SHOW_DIALOG](state, b) {
    state.dialog.dialogShow = b;
  },
  [common.DIALOG_OK](state) {
    state.dialog.dialogOkCb();
    state.dialog.dialogShow = false;
  },
  [common.DIALOG_CANCEL](state) {
    state.dialog.dialogCancelCb();
    state.dialog.dialogShow = false;
  },
  [common.TOGGLE_NAV_DRAWER](state) {
    state.navigation.drawer = !state.navigation.drawer;
  },
  [common.SET_NAV_DRAWER](state, b) {
    state.navigation.drawer = b;
  },
  [common.TOGGLE_NAV_MINI](state) {
    state.navigation.mini = !state.navigation.mini;
  },
  [common.SET_NAV_MINI](state, b) {
    state.navigation.mini = b;
  },
  [common.SET_REQUIRED_UPDATE_PASSWORD_DIALOG](state, b) {
    state.showRequiredUpdatePasswordDialog = b;
  },
  [common.SET_APPINFO](state, appInfo) {
    state.appInfo = Object.assign({}, state.appInfo, appInfo);
  },
  [common.SET_CUSTOM_HEADER_TEXT](state, text) {
    state.customHeaderText = text;
  },
};

export default mutations;
